module.exports = __webpack_public_path__ + "img/19.8db006b2.jpg";